export default __webpack_public_path__ + "static/media/accommodation6.7aadec57.webp";